<template>
  <router-link class="header-overview-link"
               :class="{ 'active': mouseOver || active }"
               :to="{ name: 'overview' }"
               @mouseenter.native="mouseOver = true"
               @mouseleave.native="mouseOver = false">
    <icon-overview class="icon"
                   width="48"
                   height="48"
                   :active="mouseOver || active"/>

    <div class="label" data-title="Overview">
      {{ $t("header.overview") }}
    </div>
  </router-link>
</template>

<script>
  export default {
    data() {
      return {
        mouseOver: false
      }
    },

    computed: {
      active() {
        return this.$route.name === 'overview'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .header-overview-link {
    display: flex;
    align-items: center;
    max-width: 150px;
    height: 100%;
    text-decoration: none;

    .icon,
    .label {
      color: #fff;
    }

    .icon {
      flex-shrink: 0;
      margin-right: 8px;
    }

    .label {
      padding: 2px 8px;
      font-size: 16px;
      line-height: 1;
      font-weight: 300;
      border-radius: 4px;
      transition: all .1s ease-out;

      &::after {
        display: block;
        content: attr(data-title);
        font-weight: bold;
        height: 0;
        overflow: hidden;
        visibility: hidden;
      }
    }

    &.active .label {
      font-weight: bold;
      color: map-get($colors, primary);
      background-color: #fff;
    }
  }
</style>